import { render, staticRenderFns } from "./EventTeamNotesDialog.vue?vue&type=template&id=c68d29be&scoped=true&"
import script from "./EventTeamNotesDialog.vue?vue&type=script&lang=js&"
export * from "./EventTeamNotesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68d29be",
  null
  
)

export default component.exports